<div class="wrapper">
  <div class="content-wrapper">
    <div class="br-section-wrapper">
      <div class="row">
        <div class="col-3 selector-initial">
          <div class="selector-container">
            <h6 class="text-center selection-header">Users</h6>

            <div class="termbar">
              <div class="well">
                <hr />
                <label for="terms-search">Search User <small>user ID</small></label>
                <div class="input-append search-bar">

                  <ngx-select-dropdown [config]="userFilterConfig" (change)="findUserModuleAccess()"
                    [options]="users?.users" [(ngModel)]="selectedUser" [multiple]="false"></ngx-select-dropdown>

                </div>
                <div class="terms-list" style="margin-top: 20px">
                  <div class="term" [ngClass]="{'selected-user': user == selectedUser}"
                    *ngFor="let user of users?.users" (click)="selectedUser = user; findUserModuleAccess()">
                    <div class="term-label">
                      <span class="name"><i class="fa fa-user"></i> {{user?.email}}</span>
                    </div>
                    <div class="score"></div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="col-3 selector-padding">
          <div class="selector-container">
            <h6 class="text-center selection-header">Products</h6>

            <div class="termbar">
              <div class="well">
                <hr />
                <label for="terms-search">Search Products 
                  <button class="button btn-primary"><i class="fa fa-plus"></i> Add</button> </label>
                <div class="input-append search-bar">

                  <ngx-select-dropdown [config]="productFilterConfig" (change)="findProductTenants()"
                    [options]="products" [(ngModel)]="selectedProduct" [multiple]="false"></ngx-select-dropdown>

                </div>
                <div class="terms-list" style="margin-top: 20px">
                  <div class="term" [ngClass]="{'selected-user': product == selectedProduct}"
                    *ngFor="let product of products" (click)="selectedProduct = product; findProductTenants()">
                    <div class="term-label">
                      <span class="name"><i class="fa fa-cog"></i> {{product?.userModule?.moduleName}}</span>
                      <i class="fa fa-trash pull-right"></i>
                    </div>
                    <div class="score"></div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-3 selector-padding">
          <div class="selector-container">
            <h6 class="text-center selection-header">Tenants</h6>
          </div>
        </div>

        <div class="col-3 selector-final">
          <div class="selector-container">
            <h6 class="text-center selection-header">Billtypes</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>